import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Link } from "components/common";
import { Alert } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseTrafficViolationNotification = ({ onDismissNotification }) => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "danger",
      className: "has-bm",
      onDismiss: () => onDismissNotification(),
      title: t("license.notifications.traffic_violation_title", { productName })
    },
    /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "license.notifications.traffic_violation_body",
        values: { productName },
        components: {
          docsLink: /* @__PURE__ */ React.createElement(Link, { to: DocsHelper.toString(DocsHelper.PAGES.LICENSE_MANAGEMENT) }),
          licenseHelp: /* @__PURE__ */ React.createElement(LicenseHelp, null)
        }
      }
    ))
  );
};
export default LicenseTrafficViolationNotification;
